<ng-template #widgetDecoration let-decoration>
  <span *ngIf="api.decorationType(decoration) === 'accentDot'" class="h-2 w-2 shrink-0 rounded-full" [ngStyle]="api.decorationStyle(decoration)"></span>
  <span *ngIf="api.decorationType(decoration) === 'accentBar'" class="h-2.5 w-10 shrink-0 rounded-full" [ngStyle]="api.decorationStyle(decoration)"></span>
  <fa-icon *ngIf="api.decorationType(decoration) === 'icon'" [icon]="api.decorationIconProp(decoration)" class="shrink-0" [ngStyle]="api.decorationStyle(decoration)"></fa-icon>
  <span *ngIf="api.decorationType(decoration) === 'badge' && api.decorationBadgeLabel(decoration)" class="shrink-0 rounded-full px-1.5 py-0.5 text-[9px] font-semibold uppercase" [ngStyle]="api.decorationStyle(decoration)">
    {{ api.decorationBadgeLabel(decoration) }}
  </span>
</ng-template>

<ng-template #slotValueBlock let-row let-area="area" let-large="large" let-alignRight="alignRight">
  <div
    class="min-w-0"
    [class.text-right]="alignRight">
    <div *ngIf="api.showSlotLabels()" class="truncate text-[11px] font-normal text-slate-500">{{ api.slotColumnLabel(area.key) }}</div>
    <div
      class="mt-0.5 flex min-w-0 items-center gap-1.5 leading-tight text-slate-950"
      [class.justify-end]="alignRight"
      [class.text-xl]="large"
      [class.text-sm]="!large"
      [class.font-semibold]="large"
      [class.font-medium]="!large"
      [ngStyle]="api.slotCellStyle(row, area.key)">
      <ng-container *ngFor="let decoration of api.slotLeftDecorations(row, area.key); trackBy: trackDecoration" [ngTemplateOutlet]="widgetDecoration" [ngTemplateOutletContext]="{ $implicit: decoration }"></ng-container>
      <fa-icon *ngIf="api.slotIconName(row, area.key)" [icon]="api.slotIconProp(row, area.key)" class="shrink-0" [ngStyle]="api.slotIconStyle(row, area.key)"></fa-icon>
      <span class="min-w-0 truncate">{{ api.slotValue(row, area.key) }}</span>
      <span *ngIf="api.slotBadgeLabel(row, area.key) as slotBadge" class="shrink-0 rounded-full px-1.5 py-0.5 text-[9px] font-semibold uppercase" [ngStyle]="api.slotBadgeStyle(row, area.key)">
        {{ slotBadge }}
      </span>
      <ng-container *ngFor="let decoration of api.slotRightDecorations(row, area.key); trackBy: trackDecoration" [ngTemplateOutlet]="widgetDecoration" [ngTemplateOutletContext]="{ $implicit: decoration }"></ng-container>
    </div>
  </div>
</ng-template>

<div *ngIf="api && leader as item" class="h-full min-h-0 w-full">
  <div class="grid h-full min-h-0 grid-rows-[auto_minmax(0,1fr)] gap-2">
    <section
      class="grid gap-4 rounded-md border border-white/70 bg-white/45 p-4 shadow-sm ring-1 ring-white/50 sm:grid-cols-[auto_minmax(0,1fr)]"
      [ngStyle]="rowStyle(item)">
      <div class="grid content-start justify-items-center gap-2">
        <div class="grid h-16 w-16 place-items-center rounded-md border border-amber-200/80 bg-amber-50/70 text-slate-950 shadow-sm">
          <fa-icon [icon]="leaderIcon" class="text-sm text-amber-500"></fa-icon>
          <span class="-mt-1 text-2xl font-semibold leading-none">1</span>
        </div>
      </div>

      <div class="grid min-w-0 gap-3">
        <div class="grid min-w-0 gap-3 sm:grid-cols-[minmax(0,1fr)_auto] sm:items-start">
          <ng-container *ngIf="titleArea as area">
            <ng-container
              [ngTemplateOutlet]="slotValueBlock"
              [ngTemplateOutletContext]="{ $implicit: item, area: area, large: true, alignRight: false }">
            </ng-container>
          </ng-container>

          <ng-container *ngIf="primaryArea as area">
            <ng-container
              [ngTemplateOutlet]="slotValueBlock"
              [ngTemplateOutletContext]="{ $implicit: item, area: area, large: true, alignRight: true }">
            </ng-container>
          </ng-container>
        </div>

        <div *ngIf="detailAreas.length" class="grid gap-2 sm:grid-cols-2">
          <ng-container *ngFor="let area of detailAreas; trackBy: trackArea">
            <div class="min-w-0 rounded-md border border-white/60 bg-white/35 px-3 py-2">
              <ng-container
                [ngTemplateOutlet]="slotValueBlock"
                [ngTemplateOutletContext]="{ $implicit: item, area: area, large: false, alignRight: false }">
              </ng-container>
            </div>
          </ng-container>
        </div>

        <div *ngIf="api.badgeLabel(item) || api.iconName(item)" class="flex min-w-0 items-center gap-2">
          <fa-icon *ngIf="api.iconName(item)" [icon]="api.iconProp(item)" class="shrink-0" [ngStyle]="api.iconStyle(item)"></fa-icon>
          <span *ngIf="api.badgeLabel(item) as badge" class="shrink-0 rounded-full px-2 py-1 text-[10px] font-semibold uppercase" [ngStyle]="api.badgeStyle(item)">
            {{ badge }}
          </span>
        </div>
      </div>
    </section>

    <section *ngIf="followers.length" class="min-h-0 overflow-auto">
      <div class="grid gap-2">
        <div
          *ngFor="let follower of followers; let followerIndex = index; trackBy: trackRow"
          class="grid grid-cols-[auto_minmax(0,1fr)] items-center gap-3 rounded-md border border-white/60 bg-white/35 px-3 py-2.5"
          [ngStyle]="rowStyle(follower)">
          <span class="grid h-10 w-10 place-items-center rounded-md border border-white/60 bg-white/45 text-sm font-semibold text-slate-800">
            {{ followerIndex + 2 }}
          </span>

          <div class="grid min-w-0 gap-2 sm:grid-cols-[minmax(0,1fr)_auto] sm:items-center">
            <ng-container *ngIf="titleArea as area">
              <ng-container
                [ngTemplateOutlet]="slotValueBlock"
                [ngTemplateOutletContext]="{ $implicit: follower, area: area, large: false, alignRight: false }">
              </ng-container>
            </ng-container>

            <ng-container *ngIf="primaryArea as area">
              <ng-container
                [ngTemplateOutlet]="slotValueBlock"
                [ngTemplateOutletContext]="{ $implicit: follower, area: area, large: false, alignRight: true }">
              </ng-container>
            </ng-container>

            <div *ngIf="detailAreas.length" class="flex min-w-0 flex-wrap gap-x-3 gap-y-1 sm:col-span-2">
              <ng-container *ngFor="let area of detailAreas; trackBy: trackArea">
                <div class="min-w-0">
                  <ng-container
                    [ngTemplateOutlet]="slotValueBlock"
                    [ngTemplateOutletContext]="{ $implicit: follower, area: area, large: false, alignRight: false }">
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
